export const textFieldDefaultProps = {
  fullWidth: true,
  InputLabelProps: {
    shrink: true,
  },
  FormHelperTextProps: {
    sx: {
      position: "absolute",
      bottom: "-1.5rem",
    },
  },
  size: "small",
} as const;

export const texFieldDefaultColumnProps = {
  ...textFieldDefaultProps,
  sx: {
    mt: "2rem",
  },
};
